// removed by extract-text-webpack-plugin
module.exports = {"container":"_3izTNBKBeCj933DaARp46v","input":"_1kKiU863zOCVVgdtRTXio3"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Prepare/Field/Menu/Text/styles.css
// module id = 3099
// module chunks = 0